import {Link} from '@ezcater/tapas';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import {twJoin} from 'tailwind-merge';

import appsFlyerQrFooter from '@/assets/apps-flyer/footer-qr.svg';
import appStore from '@/assets/images/app-store.svg';
import googlePlay from '@/assets/images/google-play.svg';
import useEzRewardsEligibility from '@/hooks/useEzRewardsEligibility';
import useRAFImprovements from '@/hooks/useRAFImprovements';
import useTracking from '@/hooks/useTracking';

const AppDownloadCta: React.FC<unknown> = () => {
  const {t} = useTranslation('common');
  const {trackClick} = useTracking();
  const {canAccessEzRewards} = useEzRewardsEligibility();
  const {showRAFImprovements} = useRAFImprovements();

  const onClick = (element: string) => {
    trackClick(`footer-app-download-${element}`);
  };

  return (
    <div
      className={twJoin(
        'flex items-center justify-between rounded-2xl p-6',
        showRAFImprovements
          ? 'gap-10 bg-peppercorn-50'
          : 'mx-auto max-w-[682px] gap-16 border border-peppercorn-200 pr-4',
        showRAFImprovements && canAccessEzRewards ? 'basis-1/2' : 'mx-auto',
      )}
    >
      <div className="flex flex-col items-start gap-2">
        <h4
          className={twJoin(
            'font-bold text-peppercorn-800',
            showRAFImprovements ? 'text-lg' : 'text-xl',
          )}
        >
          {t('components.AppDownloadCta.title')}
        </h4>
        <p className="text-left text-peppercorn-800">
          {canAccessEzRewards
            ? t('components.AppDownloadCta.description')
            : t('components.AppDownloadCta.descriptionNoRewards')}
        </p>
        <div className="flex gap-3 pt-2">
          <Link
            onClick={() => onClick('app-store')}
            href="https://ezcater.onelink.me/T4QA/uz08mhmh"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={appStore} alt={t('components.AppDownloadCta.appStore')} />
          </Link>
          <Link
            onClick={() => onClick('google-play')}
            href="https://ezcater.onelink.me/T4QA/kungbqqa"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={googlePlay} alt={t('components.AppDownloadCta.googlePlay')} />
          </Link>
        </div>
      </div>
      <Image
        alt=""
        className={twJoin(showRAFImprovements && 'h-20 w-20')}
        src={appsFlyerQrFooter.src}
        width="136"
        height="136"
      />
    </div>
  );
};

export default AppDownloadCta;
